/**
 * Microsoft Clarity: session replay + heatmaps (gratis).
 * Carga el script oficial sólo si hay project id.
 */
let initialized = false;

export function initMlvClarity({ projectId } = {}) {
  if (initialized || !projectId || typeof window === 'undefined') return;
  initialized = true;
  try {
    // Snippet oficial. Carga async; no afecta FCP.
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', projectId);
  } catch (e) {
    console.warn('[MLV] Clarity init falló:', e?.message || e);
  }
}

export function mlvClaritySetUser(uid) {
  if (!initialized || typeof window === 'undefined') return;
  try {
    if (typeof window.clarity === 'function' && uid) {
      window.clarity('identify', String(uid));
    }
  } catch (_e) {
    /* ignore */
  }
}

/** Se usa para eventos custom que aparecen como filtros en Clarity. */
export function mlvClarityEvent(name) {
  if (!initialized || typeof window === 'undefined') return;
  try {
    if (typeof window.clarity === 'function') {
      window.clarity('event', String(name));
    }
  } catch (_e) {
    /* ignore */
  }
}
